
import React from "react";
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getCookieJson } from "../utils/cookie";
import { AuthHeader } from "../containers";
import AuthPageWrapper from "../components/layout/AuthPageWrapper/AuthPageWrapper";
import { IAM_COOKIE_NAME } from "../settings/config";
import AnalysisInProgressContextWrapper from "../analysis/ContextWrapper";


const ProtectedRoute = () => {
    const location = useLocation();
    const pathname = location.pathname;
    const pagesWithoutSidebarAndHeader = ["/free-trial-setup", "/user/account/setup"]

    let isAuthenticated = false;
    const iamCookie = getCookieJson(IAM_COOKIE_NAME);
    if (iamCookie && iamCookie["access_token"]) {
        isAuthenticated = true;
    }

    if (!isAuthenticated) {
        return <Navigate to="/auth/login" replace />;
    }

    return (
        <AuthPageWrapper showSideBar={!pagesWithoutSidebarAndHeader.includes(pathname)}>
            <AuthHeader showPageHeader={!pagesWithoutSidebarAndHeader.includes(pathname)} />
            <AnalysisInProgressContextWrapper>
                <Outlet />
            </AnalysisInProgressContextWrapper>
        </AuthPageWrapper>
    );
};

export default ProtectedRoute;
